module.exports = __webpack_public_path__ + "static/media/OscarPeterson.9867b98b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/Center/Block/img/OscarPeterson.jpeg
// module id = 617
// module chunks = 0